export default __webpack_public_path__ + "67a7bab20911543dfca289be1cb23224.png";